import { Button, Row } from "antd";

type FormButtonsProps = {
  isLoading: boolean;
  onExport: () => void;
  closeModal: () => void;
};

export const FormButtons = ({
  isLoading,
  onExport,
  closeModal,
}: FormButtonsProps) => {
  return (
    <Row className="justify-end pt-8">
      <Button
        className="mr-4"
        shape="round"
        type="primary"
        disabled={isLoading}
        loading={isLoading}
        onClick={onExport}
      >
        Export
      </Button>
      <Button shape="round" disabled={isLoading} onClick={closeModal}>
        Cancel
      </Button>
    </Row>
  );
};
